import { useEffect, useState } from "react";
import { applyTheme, loadTheme, ThemeMode } from "../utils/theme";

export const useTheme = () => {
  const [theme, setTheme] = useState<ThemeMode>(loadTheme);

  useEffect(() => {
    applyTheme(theme);
  }, [theme]);

  return {
    theme,
    setTheme,
    toggleTheme: () => setTheme(prev => (prev === "light" ? "dark" : "light")),
  };
};
